import { request } from '../utils/request';
import { fileApi } from '../config/urlConfig';

/**
 * 上传文件.
 */
export const uploadFile = (data: any, headers?: any) =>
  request({
    url: `${fileApi}/file/upload?type=file&source=form`,
    method: 'post',
    data,
    headers,
    flag: true,
    isNotJsonType:true
  });
